import styles from './MainNavigation.module.css'; 

function MainNavigation(){
    return (
    <header className={styles.header}>
        <div className={styles.logo}>2024 Portfolio</div>
        <div>
            <ul>
                <li>
                    <a href="http://mattwdeacon.com/">Back to MattWDeacon.com</a>
                </li>
            </ul>
        </div>
    </header>
    )
}

export default MainNavigation